<template>       
  <title-tab :msg="$t('title.status')">  
    <v-row
      no-gutters 
    >
      <v-col
        class="px-1 mt-3"
        cols="12"
        md="8"
      >
        <v-card
          flat
          height="100%"
          class="py-3 d-flex justify-center"
        >
          <v-col
            cols="12"
            sm="6"
          >
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('status') }} </b>
              </v-col>
              <v-col class="green--text">
                {{ $t('normal') }}
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('login-name') }} </b>
              </v-col>
              <v-col v-if="userProfile.username"> 
                {{ userProfile.username }}  
              </v-col>
              <v-col v-else>
                -
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('name-surname') }} </b>
              </v-col>
              <v-col v-if="userProfile.first_name">
                {{ userProfile.first_name }}  {{ userProfile.last_name }} 
              </v-col>
              <v-col v-else> 
                - 
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('birthdate') }} </b>
              </v-col>
              <v-col v-if="userProfile.birthdate "> 
                {{ userProfile.birthdate }}  
              </v-col> 
              <v-col v-else>
                - 
              </v-col>
            </v-row>
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('line') }} </b>
              </v-col>
              <v-col v-if="userProfile.line_id"> 
                {{ userProfile.line_id }}
              </v-col>
              <v-col v-else>
                -
              </v-col> 
            </v-row>
            <v-row
              no-gutters
              class="py-2"
            >
              <v-col class="text-start">
                <b> {{ $t('email') }} </b>
              </v-col>
              <v-col v-if="userProfile.email">
                {{ userProfile.email }} 
              </v-col>
              <v-col v-else>
                -
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
      <v-col
        class="px-1 mt-3"
        cols="12"
        md="4"
      > 
        <v-row
          v-for="(item,i) in userProfile.user_stake_summary"
          :key="i"
          no-gutters
        >
          <v-card
            flat
            width="100%"
            class="text-center mb-3 py-2"
          >
            {{ $t('balance') }}{{ item.category_game_type.name }}<p class="blue--text">
              <b>{{ item.amount }}</b>
            </p>
          </v-card>
        </v-row> 
        <v-row no-gutters>
          <v-card
            flat
            width="100%"
            class="text-center py-2"
          >
            {{ $t('your-status') }}<p class="blue--text">
              <b> {{ (userProfile.role || {}).title }} </b>
            </p>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
    <v-card
      v-if="threshold.length!==0 && false"
      flat
      class="mt-3 py-3 mx-1"
    >
      <v-row
        v-for="(item,i) in threshold"
        :key="i" 
        no-gutters
        class="my-1"
      >
        <v-col class="text-end mr-2">
          VIP {{ i+1 }}
        </v-col>
        <v-col>
          <v-progress-linear
            :value="checkVip2(
              threshold[i-1]?threshold[i-1].purchased_threshold:0,
              item.purchased_threshold)"
            color="amber"
            height="25"
            buffer-value="0"
            stream
          />
        </v-col>
        <v-col class="px-2">
          {{ item.purchased_threshold }}
        </v-col>
      </v-row> 
    </v-card>  
    <v-card  
      v-if="PricingList.length!==0 && false"
      flat
      class="mt-3 mx-1"
    >
      <div
        v-for="(item,i) in PricingList"
        :key="i"
      > 
        <v-data-table
          :headers="headers.map(x=>{
            x.text=$t(x.text)
            return x
          })"
          :items="item.price"
          hide-default-footer
        >
          <template v-slot:top>
            <div class="blue--text pa-3">
              {{ item.game_type.name }}
            </div>
          </template>
        </v-data-table>
      </div>  
    </v-card> 
  </title-tab>   
</template>
<script>
import { gamePricing as apiGamePricing, vipRanks as apiVipRanks } from '@/apis' 

export default { 
  data () {
    return {
      headers: [
       { text: 'table.name', value: 'number_type_name' },
       { text: 'table.reward', value: 'reward' },
       { text: 'table.vip1', value: 'vip1_add_on' },
       { text: 'table.vip2', value: 'vip2_add_on' },
       { text: 'table.vip3', value: 'vip3_add_on' },
       { text: 'table.vip4', value: 'vip4_add_on' }, ],
      PricingList : [],  
      threshold:[],   
    }
  }, 
  computed : {
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  async mounted () {   
    this.$store.dispatch('userProfile/ACTION_ME')
    this.loadVipRank()
    this.load()
  },

  methods: { 
    async loadVipRank () {
      const [err, data] = await apiVipRanks.get()

      if(err){
        this.$alert('',err,'warning') 
        return
      } 

      this.threshold = data     
    },

    async load () {
      const [err, data] = await apiGamePricing.get()
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }
      
      this.PricingList = data  
    },

    checkVip2 (previousThreshold,currentThreshold) { 
      if(this.userProfile.upline===null) { 
        currentThreshold <= 0 ? 1 :currentThreshold 
        var value = this.wallet.total_bet_amount - previousThreshold
        value = value <= 0 ? 0 : value 
        return value*100/(currentThreshold-previousThreshold)
      } else {
        return 0
      }
    }, 
  }
}
</script> 